import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { clearAuth } from '@/redux/auth/authSlice';

// The server's TOTAL unread-notification count, mirrored from the
// `custom-notifications` response header (see api/notificationsHeader.ts).
// Written by axiosBaseQuery on every company-session response whose header
// differs, and optimistically by the read / read-all mutations in
// notificationsApi (restored on failure). Read by the header bell badge and
// the panel head in NotificationsMenu. Blacklisted from redux-persist in
// store.ts — a stale persisted count would flash on reload, and the first
// authenticated response rewrites it anyway.
export interface NotificationsState {
  unreadCount: number;
}

const initialState: NotificationsState = {
  unreadCount: 0,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },
  },
  // Session ends → drop the count (the api cache is reset by sessionListener).
  extraReducers: (builder) => {
    builder.addCase(clearAuth, () => initialState);
  },
});

export const { setUnreadCount } = notificationsSlice.actions;
export default notificationsSlice;
